export class Fancybox {
  /* exécuter au lancement de fancybox, puis à chaque clic dans fancybox. */
  static onActivate(func: (event?: JQuery.Event) => void) {
    $.fancybox.defaults.onActivate = function () {
      func();
      $(".fancybox-container").on("click", func);
    };
  }

  static offActivate(func: (event?: JQuery.Event) => void) {
    $(".fancybox-container").off("click", func);
    $.fancybox.defaults.onActivate = $.noop;
  }
}
